<template>
  <v-container class="pa-0 pt-4">
    <div
      class="global-typography"
      v-if="
        isSitecoreExperienceEditorOn ||
          (fields.SectionTitle && fields.SectionTitle.value && fields.SectionTitle.value !== '')
      "
    >
      <sc-text
        :field="this.fields.SectionTitle"
        tag="h2"
        class="section-title"
        :class="{
          'pb-6': $vuetify.breakpoint.smAndUp,
          'pb-3': $vuetify.breakpoint.xsOnly,
        }"
      />
    </div>
    <v-row>
      <v-col cols="12" class="py-0">
        <sc-placeholder name="jssimagecards" :rendering="rendering" class="image-cards-row row" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Text, Placeholder, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'ImageCards',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss" scoped>
.image-cards-row {
  &::v-deep {
    .promo-content-card {
      min-width: 300px;
      margin-left: 12px;
      margin-right: 12px;
      margin-bottom: 16px !important;
      @media #{map-get($display-breakpoints, 'lg-and-up')} {
        width: calc(100% / 3 - 24px) !important;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        width: calc(100% - 24px);
      }
      @media #{map-get($display-breakpoints, 'sm-and-up')} {
        width: calc(100% / 2 - 24px);
        height: auto !important;
      }
    }
  }
}
</style>
